import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-door-closed",
  "use": "icon-door-closed-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" class=\"bi bi-door-closed\" fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-door-closed\">\r\n  <path fill-rule=\"evenodd\" d=\"M3 2a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v13h1.5a.5.5 0 0 1 0 1h-13a.5.5 0 0 1 0-1H3V2zm1 13h8V2H4v13z\" />\r\n  <path d=\"M9 9a1 1 0 1 0 2 0 1 1 0 0 0-2 0z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/door-closed.svg
// module id = k2+i
// module chunks = 60